import React from 'react';
import User from '../../models/User';
import './UserAvatar.css';
import Tooltip from './Tooltip';
import { TopBarVisibility } from '../layout/TopBarVisibility';

export const UserAvatar = ({ user, tooltip, simple, border }) => (
  <div className="row no-gutters">
    <div
      className={ `no-flex ${!simple ? 'display-if-large-enough' : ''} ${!!border
        ? `avatar-border d-flex ${user ? TopBarVisibility.isViewingAs(user)
          ? 'avatar-border-viewing-as'
          : 'avatar-border-normal' : ''}`
        : ''}` }>
      <Avatar user={ user } />
    </div>

    { !simple && <Email user={ user } tooltip={ tooltip } /> }
  </div>
);

/**
 * Display an avatar - either the image or user initials
 *
 * @param user MiniUser object
 * @returns {*} JSX for Avatar
 * @constructor object as named prop
 */
const Avatar = ({ user }) => {
  const avatar = user ? User.getMediaAvatarPhoto(user) : null;
  const initials = user ? (User.getInitials(user) || '') : '';
  return (
    <div className="avatar">
      { avatar
        ? (
          <img
            src={ avatar }
            alt="User Avatar"
            className="fit-avatar" />
        )
        : (
          <div className="initials d-flex h-100 w-100 align-items-center">
            <span className="m-auto">{ initials }</span>
          </div>
        ) }
    </div>
  );
};

/**
 * Display user email
 *
 * @param user MiniUser object
 * @param tooltip Optional tooltip text
 * @returns {*} JSX for Email
 * @constructor object as named prop
 */
const Email = ({ user, tooltip }) => {
  const email = user ? (User.getEmail(user) || 'Not available') : 'Not available';
  const content = (
    <div className="text-truncate pr-2 ml-3">
      <span className="align-middle">{ email }</span>
    </div>
  );

  if (tooltip) {
    return (
      <Tooltip tooltip={ tooltip }>
        { content }
      </Tooltip>
    );
  }
  return content;
};

